/// <reference path="../interfaces/ialternativebrands.ts" />
module App.Classes {
    export interface IComposition {
        pipeline: string
        licensePlate: string
        storeId: number
        apiStoreId: number
        storeName: string
        carInformation: ILicensePlateInformation
        products: Interfaces.IProduct[]
        selectedProducts: Interfaces.IProduct[]
        stores: IStore[]
        mileage: number
        mileageUnknown: boolean
        establishment: IStore
        dates: Interfaces.IDate[]
        selectedDate: Interfaces.IDate
        times: Interfaces.ITime[]
        selectedTime: string
        replacementVehicles: Interfaces.IReplacementVehicle[]
        selectedReplacementVehicle: Interfaces.IReplacementVehicle
        postalCode: string
        houseNumber: string
        address: Interfaces.IAddress
        collectAddress: Interfaces.IAddress
        deliverAddress: Interfaces.IAddress
        selectedDiscountVoucher: string
        activeDiscounts: Interfaces.IDiscount[]
        remarks: string
        privacyCheck: boolean
        enableDateSelection: boolean
        allowColorChange: boolean
        franchiseId: number
        showInfoPopup: boolean
        showBrandsPopup: boolean
        infoPopupStepName: string
        infoPopupContent: string
        allowWaitingTimes: Interfaces.ITime[]
        unkownLicense: boolean
        customCarBrand: string
        customCarModel: string
        customCarFuel: string
        recurringCustomer: boolean
        newsletter: boolean

        storeSelected: boolean
        waitForJob: boolean
        categoryHelpDescriptions: Interfaces.ICategoryDescription[]
        requiresReplacementVehicle: boolean
        alternativeBrands: Interfaces.IAlternativeBrands[]
        alternativeUrl: string

        redirectPopupContent: string
        noStoresAvailablePopupContent: string
        apkWarning: boolean
        maintenanceWarning: boolean
        tireWarning: boolean
        allAllowedStores: any[]
        utmParams: Interfaces.IUtmParam[]
        leaseCar: string
    }

    export class Composition implements IComposition {
        constructor() {
            this.licensePlate = ''
        }

        unkownLicense: boolean
        customCarBrand: string
        customCarModel: string
        customCarFuel: string

        pipeline: string
        licensePlate: string
        storeId: number
        apiStoreId: number
        storeName: string
        carInformation: ILicensePlateInformation
        products: Interfaces.IProduct[]
        selectedProducts: Interfaces.IProduct[]
        stores: IStore[]
        mileage: number
        mileageUnknown: boolean
        establishment: IStore
        dates: Interfaces.IDate[]
        selectedDate: Interfaces.IDate
        times: Interfaces.ITime[]
        selectedTime: string
        replacementVehicles: Interfaces.IReplacementVehicle[]
        selectedReplacementVehicle: Interfaces.IReplacementVehicle
        postalCode: string
        houseNumber: string
        address: Interfaces.IAddress
        collectAddress: Interfaces.IAddress
        deliverAddress: Interfaces.IAddress
        selectedDiscountVoucher: string
        activeDiscounts: Interfaces.IDiscount[]
        remarks: string
        privacyCheck: boolean
        enableDateSelection: boolean
        allowColorChange: boolean
        franchiseId: number
        showInfoPopup: boolean
        showBrandsPopup: boolean
        infoPopupStepName: string
        infoPopupContent: string
        allowWaitingTimes: Interfaces.ITime[]
        recurringCustomer: boolean
        newsletter: boolean

        storeSelected: boolean
        waitForJob: boolean
        categoryHelpDescriptions: Interfaces.ICategoryDescription[]
        requiresReplacementVehicle: boolean
        alternativeBrands: Interfaces.IAlternativeBrands[]
        alternativeBrand: string
        alternativeUrl: string
        staticAlternativeBrand: string
        staticAlternativeUrl: string
        redirectPopupContent: string
        noStoresAvailablePopupContent: string
        apkWarning: boolean
        maintenanceWarning: boolean
        tireWarning: boolean
        allAllowedStores: any[]
        utmParams: Interfaces.IUtmParam[]
        leaseCar: string
    }
}